import React, { useRef, useState } from 'react';
import styled from 'styled-components';

export default function TermsTitleBox(props) {
	const { value, setValue, placeholder } = props;

  const [isFocused, setIsFocused] = useState(false);

	const InputRef = useRef();

	function handleChange(e) {
		setValue(e.target.value);
	}

	function handleFocus(e) {
    setIsFocused(true);
	}

	function handleBlur(e) {
    setIsFocused(false);
	}

  return (
    <TopLevelWrapper>
      <Input
        ref={InputRef}
        value={value}
        placeholder={isFocused ? '' : placeholder}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur} />
    </TopLevelWrapper>
  )
};

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: calc(100% - 4px);
  height: 36px;

  border: 2px dotted ${props => props.theme.text};
  border-radius: 5px;
  background-color: ${props => props.theme.buttonFill};
`;

const Input = styled.input`
	font-family: NotoSansKR-Bold;
	font-size: 16px;
	
	padding: 0 0 0 0;
  margin: 0 0 0 0;

	outline: none;
	border: 0px solid ${props => props.theme.subBackground};
	color: ${props => props.theme.text};

	width: 80%;
	height: 30px;

  text-align: center;

  background-color: ${props => props.theme.buttonFill};

	::placeholder {
		color: ${props => props.theme.line};
	}
`;